import Corporation from "./Corporation";
export default Corporation;
